<script setup>
import ToolTip from '../ToolTip.vue';
import Sheet from './../Sheet.vue';
import { formatDateString, formatWeekday } from './utils';

const props = defineProps({
    day: {
        type: Object,
        required: true
    },
    activeDay: {
        type: String,
        required: true
    }
});
const emit = defineEmits(['handleStream']);

const handleShowStream = (latestContentstreamId) => {
    emit('handleStream', latestContentstreamId);
};
const formatEventName = (name) => {
    if (!name) return '';

    return name.split('(')[0].trim();
};
</script>

<template>
    <div class="mt-2">
        <div v-if="(props.day?.items?.length || 0) === 0" class="w-full h-full flex items-center justify-center">
            <Sheet flat compact class="max-w-[200px]">
                <div class="flex justify-center pb-4">
                    <div class="inline-block px-3 py-1 rounded-full text-sm font-extralight bg-gray-200 text-gray-700">
                        {{ formatWeekday(props.day.date) }}: {{ formatDateString(props.day.date) }}
                    </div>
                </div>
                <span v-if="props.day.messages && props.day.messages.length" class="text-center break-words">
                    <div v-for="(message, index) in props.day.messages" :key="index" class="block break-words">{{ message }}</div>
                </span>
            </Sheet>
        </div>

        <Sheet v-else flat compact class="h-full w-full flex flex-col">
            <div :class="['inline-block px-4 py-1 rounded-full text-sm font-extralight', props.day.date === activeDay ? 'bg-blue text-white' : 'bg-gray-200 text-gray-700']">
                {{ formatWeekday(props.day.date) }}: {{ formatDateString(props.day.date) }}
            </div>

            <div class="calendarListCard grid grid-cols-12 sm:grid-cols-3 gap-2 items-start mt-4">
                <div v-for="event in props.day.items" :key="event.id" class="col-span-3 sm:col-span-1 flex justify-start items-start">
                    <ToolTip :text="`${$t('plain_analysis')}: ${formatEventName(event.name)}`">
                        <img
                            v-if="event.logo"
                            :src="event.logo"
                            :class="event?.latest_contentstream ? 'cursor-pointer hover:scale-150 hover:border-blue ' : 'opacity-50 cursor-not-allowed '"
                            class="h-10 w-10 object-fit rounded-full border border-gray-300 transition-transform duration-400"
                            :alt="event.name"
                            @click="event?.latest_contentstream && handleShowStream(event?.latest_contentstream)"
                        />
                        <div
                            v-else
                            :class="event?.latest_contentstream ? 'cursor-pointer hover:scale-150 hover:border-blue ' : 'opacity-50 cursor-not-allowed '"
                            class="h-10 w-10 object-fit rounded-full border border-gray-300 bg-blue transition-transform duration-400"
                            :alt="event.name"
                            @click="event?.latest_contentstream && handleShowStream(event?.latest_contentstream)"
                        ></div>
                    </ToolTip>
                </div>
            </div>
        </Sheet>
    </div>
</template>
